import { compose } from 'recompose';
import { withNamespaces } from 'react-i18next';
import TabWrapperMobile from './tabWrapperMobile';

const enhance = compose(
  withNamespaces(['common']),
);

export default enhance(TabWrapperMobile);
